<template>
    <v-hover>
        <v-card flat hover slot-scope="{ hover }">
            <v-card-text>
                <div class="display-1">{{ (value.label)? value.label : d.label }}</div>
                <template v-for="o in value.opciones">
                    <v-checkbox :label="o"></v-checkbox>
                </template>
                <div v-if="hover">
                    <br>
                    <v-divider></v-divider>
                    <v-layout>
                        <v-flex>
                            <v-text-field label="Etiqueta" v-model="d.label" @input="input"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-combobox
                                    v-model="value.opciones"
                                    :items="items"
                                    multiple
                                    chips
                                    label="Ingrese las opciones"
                                    @input="input"
                            ></v-combobox>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card-text>
        </v-card>
    </v-hover>
</template>

<script>
    export default {
        name: "check",
        props: ['value'],
        data() {
            return {
                d: {
                    label: 'Titulo',
                    opciones: []
                },
                items: []
            }
        },
        methods: {
            input() {
                this.$emit('input', this.d);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/formulario/tipos/check.vue